import React from "react";
import ConfirmationModal from "../../../components/features/ConfirmationModal";

const TemplateArchiveModal = ({
  templateName,
  onRequestClose,
  onConfirm,
}: {
  templateName: string;
  onRequestClose: () => void;
  onConfirm: () => void;
}) => {
  return (
    <ConfirmationModal
      isOpen={true}
      onRequestClose={onRequestClose}
      onConfirm={onConfirm}
      title="Confirm Archive"
      message={
        <>
          Are you sure you want to archive <strong>"{templateName}"</strong>?
        </>
      }
      confirmText="Archive"
      width={550}
    />
  );
};

export default TemplateArchiveModal;
